//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "./rejectTopicEditModalView",
  "modules/tasks/tasksModel",
], function ($, Marionette, Messenger, RejectTopicEditModalView, TaskModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "rejectTopicEditModal";
    },
    show: function (topicEditRequest) {
      this.topicEditRequest = topicEditRequest;
      this.view = new RejectTopicEditModalView.view({ model: topicEditRequest });
      this.view.on("cancel", this.onCancel, this);
      this.view.on("sendResponse", this.onSendResponse, this);
      this.showRegion(this.view, { loading: true });
      topicEditRequest.onSynced(function () {
        this.view.render();
      }, this);
    },
    onCancel: function () {
      Messenger.vent.trigger("cancel:textbox");
      // Do not save anything, throw it away
      Messenger.vent.trigger("close:modal");
    },
    onSendResponse: function () {
      const topicEditRequest = this.topicEditRequest;
      if (Messenger.reqres.request("save:textbox")) {
        const response = this.view.getResponse();
        if (!response || !response.trim()) {
          this.view.responseError($.t("commonMessages.emptyMessage"));
          return;
        }
        topicEditRequest.set("response", response);
        topicEditRequest.set("status", TaskModel.TOPIC_EDIT_STATUS.REJECTED);
        Messenger.vent.trigger("show:saving:display");
        topicEditRequest.saveModel({
          error: function (model, resp) {
            Messenger.vent.trigger("close:saving:display");
            Messenger.showErrorFromResponse(resp);
          },
          success: function () {
            topicEditRequest.dirty = false;
            Messenger.vent.trigger("close:saving:display");
            Messenger.vent.trigger("close:modal");
          },
        });
      }
    },
  });
});
